import React, { Fragment, PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classnames from 'classnames';
import { Link } from 'react-router-dom';
import { injectIntl, FormattedMessage } from '../../../../components/Intl/withIntl.js';
import { Accordion, Container, Row, Col, ButtonGroup, Button } from 'react-bootstrap';


import config from '../../../../config.js';
import { shuffle } from '../../../../util/array.js';

import { getReviews, getReviewSummaryRequest } from '../../ReviewActions.js';
import { getConfig } from '../../../Config/ConfigActions.js';

import Icon from '../../../../components/Content/Icon.js';
import Slider from '../../../../components/Content/Slider.js';

import ReviewListItem from '../list/ReviewListItem.js';

class ReviewSummary extends PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            reviews: [],
            type: 'review', // || 'question'
            isLoaded: true,
        };
    }

    // componentDidMount() {
	// 	this.init();
    // }

    componentDidUpdate(prevProps, prevState) {
        if(prevProps.intl.locale !== this.props.intl.locale) {
            this.init();
        }
    }

    handleVisibilityChange = isVisible => {
        if(isVisible && !this.state.isLoaded) {
            this.init();
        }
    };

    init = () => {
        !this.props.hideReviews && this.props.dispatch(getReviewSummaryRequest(this.props.intl.locale, (this.props.product || {})._id, this.state.type === 'question')).then(result => {
            this.setState({
                ...result,
                isLoaded: true,
            });
        });
    };

    toggleType = type => {
        this.setState({ type }, this.init);
    };

    handleViewReview = () => this.toggleType('review');

    handleViewQuestion = () => this.toggleType('question');

    render() {
        const reviewsCountPerSlide = this.props.countPerSlide || (this.props.appIsMobile ? 1 : 3);
        const reviewsGroups = [];
        const reviews = (this.state.reviews || []).concat(this.props.reviews).filter(review => { return this.state.type === 'review' ? review.score : !review.score; });
        const reviewsTemp = [...(this.props.isRandom ? shuffle(reviews) : reviews)];
        while(reviewsTemp.length > 0) {
            reviewsGroups.push(reviewsTemp.splice(0, reviewsCountPerSlide));
        }

        const colSize = 12 / reviewsCountPerSlide;

        const slides = reviewsGroups.map((reviews, indexGroup) => {
            return (
                <Row key={indexGroup} className="gy-2">
                    {reviews.map((review, indexReview) => (
                        <Col key={review._id} xs="12" lg={colSize}>
                            <ReviewListItem review={review} index={(indexGroup * reviewsCountPerSlide) + (indexReview + 1)} />
                        </Col>
                    ))}
                </Row>
            );
        });

        return (
            // <VisibilitySensor onChange={this.handleVisibilityChange}>
                <div className="py-4">
					{/* {!this.props.hideLogo && (
						<div className="text-center">
							<picture>
								<source srcSet={`${config.url}assets/images/contact.webp`} type="image/webp" loading="lazy" />
								<img src={`${config.url}assets/images/contact.png`} alt="Contact" width="110" height="65" style={{ width: '110px' }} loading="lazy" />
							</picture>
							<br />
						</div>
					)}
					*/}
					{!this.props.hideTitle && <h2 className="h3 fw-bold text-dark text-center mb-3"><FormattedMessage id="reviewsTitle" defaultMessage="Our customer reviews" /></h2>}

					{!this.props.hideSummary && parseFloat(this.props.rate) > 0 && (
						<div className="mx-auto mb-3" style={{ maxWidth: '640px' }}>
							<div className="p-3 p-md-4 bg-white border rounded-3 d-flex flex-wrap align-items-center justify-content-center gap-3 gap-md-4">
								<span className="fw-bold text-dark lh-1" style={{ fontSize: '2.6rem' }}>
									{parseFloat(this.props.rate).toLocaleString(this.props.intl.locale, { minimumFractionDigits: 1 })}
									<span className="text-muted" style={{ fontSize: '1.1rem' }}>/{config.application.rating.max}</span>
								</span>
								<div className="d-flex flex-column align-items-center align-items-md-start gap-1">
									<div className="starRating starRatingSmall">
										<div style={{ width: `${(parseFloat(this.props.rate) * 100) / config.application.rating.max}%` }}>{' '}</div>
									</div>
									<span className="small text-muted"><FormattedMessage id="reviewsGoogleVerified" defaultMessage="Google rating · verified customer reviews" /></span>
								</div>
								<div className="d-flex flex-wrap justify-content-center gap-2 ms-md-auto">
									<span className="badge rounded-pill bg-light text-body border fw-bold">🚚 <FormattedMessage id="reviewTagFastDelivery" defaultMessage="Fast delivery" /></span>
									<span className="badge rounded-pill bg-light text-body border fw-bold">😋 <FormattedMessage id="reviewTagGreatTaste" defaultMessage="Great taste" /></span>
								</div>
							</div>
						</div>
					)}

					<Container className="text-center">
						{!this.props.hideReviews && !this.props.hideQuestions && (
							<ButtonGroup>
								<Button variant="link" className={classnames(this.state.type !== 'review' && 'text-black-75')} onClick={this.handleViewReview}>{this.state.type === 'review' ? <FormattedMessage id="reviews" defaultMessage="Reviews" /> : <FormattedMessage id="reviewsRead" defaultMessage="Read reviews" />} {this.state.type !== 'review' && <Icon icon="arrow-right" />}</Button>
								<Button variant="link" className={classnames(this.state.type !== 'question' && 'text-black-75', 'border-left')} onClick={this.handleViewQuestion}>{this.state.type === 'question' ? <FormattedMessage id="reviewQuestions" defaultMessage="Questions" /> : <FormattedMessage id="reviewQuestionsRead" defaultMessage="Read questions" />} {this.state.type !== 'question' && <Icon icon="arrow-right" />}</Button>
							</ButtonGroup>
						)}

						{this.state.isLoaded && !this.props.hideReviews && (
							<div className="px-3 pb-2 px-md-0 slider-alt">
								{!this.state.isLoaded && (
									<div className="text-center">
										<Icon icon="spinner" spin size="3x" />
									</div>
								)}
								{
									this.state.type === 'review' || this.props.hideQuestions
									? <Slider
										slides={slides.map(content => ({ content }))}
										disableLightbox
										disableControls={false}
										disableIndicators={false}
										interval={process.env.NODE_ENV === 'development' ? 99999999999 : 6000}
									/>
									: (
										<div className="px-2 px-md-0 text-start">
											<Accordion alwaysOpen>
												<Row className="align-items-start">
													{[
														{ id: 'question-col-left', offset: 0, items: reviews.slice(0, Math.ceil(reviews.length / 2)) },
														{ id: 'question-col-right', offset: Math.ceil(reviews.length / 2), items: reviews.slice(Math.ceil(reviews.length / 2)) },
													].map(column => (
														<Col xs="12" lg="6" key={column.id}>
															{column.items.map((review, index) => (
																<Accordion.Item eventKey={`${column.offset + index}`} key={review._id} className="mb-0">
																	<Accordion.Header>
																		<span className="h6 fw-semibold mb-0">{review.text}</span>
																	</Accordion.Header>
																	<Accordion.Body>{review.answer}</Accordion.Body>
																</Accordion.Item>
															))}
														</Col>
													))}
												</Row>
											</Accordion>
											<p className="text-center">
												<span className="d-block h3 my-3"><FormattedMessage id="reviewQuestionAsk" defaultMessage="Any question about our products or services?" /></span>
												<Button color="outline-secondary" size="sm" as={Link} to={`/${this.props.intl.locale}/page/contact`}><FormattedMessage id="contactPageTitle" defaultMessage="Contact us" /></Button>
											</p>
										</div>
									)
								}
							</div>
						)}
					</Container>
                </div>
            // </VisibilitySensor>

        );
    }
}

function mapStateToProps(store, props) {
	return {
		reviews: getReviews(store),
		appIsMobile: store.app.isMobile,
		rate: getConfig(store, 'star-rating'),
	};
}

ReviewSummary.defaultProps = {
    isRandom: false,
    hideTitle: false,
    hideSummary: false,
    hideReviews: false,
    hideQuestions: false,
    product: null,
    appIsMobile: false,
	rate: 0,
};

ReviewSummary.propTypes = {
    dispatch: PropTypes.func.isRequired,
    intl: PropTypes.object.isRequired,
	reviews: PropTypes.arrayOf(PropTypes.object).isRequired,
    isRandom: PropTypes.bool,
    hideTitle: PropTypes.bool,
    hideSummary: PropTypes.bool,
    hideReviews: PropTypes.bool,
    hideQuestions: PropTypes.bool,
	countPerSlide: PropTypes.number,
    product: PropTypes.object,
    appIsMobile: PropTypes.bool,
	rate: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export default connect(mapStateToProps)(injectIntl(ReviewSummary));
